import { Industry } from '__generated__/Industry';
import IndustryField from 'projects/components/BriefFields/IndustryField';
import OtherField from 'projects/components/BriefFields/OtherField';
import ProfileApprovalField from 'projects/components/BriefFields/ProfileApprovalField';
import ContentSetting from 'projects/components/ContentSetting';
import { ObservableForm } from 'projects/components/ObservableForm';
import { trackViewedBriefEvent } from 'projects/events';
import React, { useEffect } from 'react';

interface Fields {
    industry: string;
    profileApproval: boolean;
    other: string;
}

export interface Props<T> {
    form: ObservableForm<T>;
    brief: {
        id: string;
    };
    industries: Industry[];
}

export default function AboutYouPage<T extends Fields>(props: Props<T>) {
    const { form, brief, industries } = props;

    useEffect(() => {
        trackViewedBriefEvent({ id: brief.id, page: 'AboutYou' });
    }, []);

    return (
        <ContentSetting>
            <IndustryField form={form} industries={industries} />
            <ProfileApprovalField form={form} />
            <OtherField form={form} />
        </ContentSetting>
    );
}
